import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        // Preserve the path the user came back to (e.g. /messages, /settings)
        // — only the OAuth hash needs stripping. Default to /oracle when the
        // OAuth callback lands at root. First-session onboarding (welcome +
        // push nudge) is handled globally by ThresholdRitual — no branching
        // here.
        const target = window.location.pathname && window.location.pathname !== "/"
          ? window.location.pathname
          : "/oracle";
        window.history.replaceState(null, "", target);
        navigate(target, { state: { user: data.user }, replace: true });
      })
      .catch((err) => {
        console.error("google session exchange failed", err);
        navigate("/login");
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="serif italic text-2xl text-foreground/75">The threshold opens…</div>
        <div className="label mt-4">Establishing session</div>
      </div>
    </div>
  );
}
